<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Licencia Oficial Colectiva</div>
    </v-card-title>

    <v-card-text>
      <v-tabs class="mb-3" v-model="selectedTab" color="secondary">
        <v-tab class="font-weight-bold">LOC</v-tab>
        <v-tab class="font-weight-bold">Remesas</v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1" eager>
          <LicenciaOficialColectivaTabContent />
        </v-tab-item>
        <v-tab-item key="2" eager>
          <RemesasTabContent />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex'
import LicenciaOficialColectivaTabContent from '@src/components/armeria/licencia-oficial-colectiva/tab-content/LicenciaOficialColectivaTabContent.vue'
import RemesasTabContent from '@src/components/armeria/licencia-oficial-colectiva/tab-content/RemesasTabContent.vue'

export default {
  components: {
    LicenciaOficialColectivaTabContent,
    RemesasTabContent,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  async created() {
    await this.fetchLocs()
    await this.fetchRemesas()
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),
    ...mapActions('remesas', ['fetchRemesas']),
  },
}
</script>
